import { ElMessage } from "element-plus"

/**
 *
 * @param component 需要注册的组件
 * @param alias 组件别名
 * @returns any
 */
export const withInstall = <T>(component: T, alias?: string) => {
  const comp = component as any
  comp.install = (app: any) => {
    app.component(comp.name || comp.displayName, component)
    if (alias) {
      app.config.globalProperties[alias] = component
    }
  }
  return component as T & Plugin
}

/**
 * @param str 需要转下划线的驼峰字符串
 * @returns 字符串下划线
 */
export const humpToUnderline = (str: string): string => {
  return str.replace(/([A-Z])/g, '-$1').toLowerCase()
}

/**
 * @param str 需要转驼峰的下划线字符串
 * @returns 字符串驼峰
 */
export const underlineToHump = (str: string): string => {
  if (!str) return ''
  return str.replace(/\-(\w)/g, (_, letter: string) => {
    return letter.toUpperCase()
  })
}

/**
 * 驼峰转横杠
 */
export const humpToDash = (str: string): string => {
  return str.replace(/([A-Z])/g, '-$1').toLowerCase()
}

export const setCssVar = (prop: string, val: any, dom = document.documentElement) => {
  dom.style.setProperty(prop, val)
}

export const getCssVar = (prop: string, dom = document.documentElement) => {
  return getComputedStyle(dom).getPropertyValue(prop)
}

/**
 * 查找数组对象的某个下标
 * @param {Array} ary 查找的数组
 * @param {Functon} fn 判断的方法
 */
// eslint-disable-next-line
export const findIndex = <T = Recordable>(ary: Array<T>, fn: Fn): number => {
  if (ary.findIndex) {
    return ary.findIndex(fn)
  }
  let index = -1
  ary.some((item: T, i: number, ary: Array<T>) => {
    const ret: T = fn(item, i, ary)
    if (ret) {
      index = i
      return ret
    }
  })
  return index
}

export const trim = (str: string) => {
  return str.replace(/(^\s*)|(\s*$)/g, '')
}

/**
 * @param {Date | number | string} time 需要转换的时间
 * @param {String} fmt 需要转换的格式 如 yyyy-MM-dd、yyyy-MM-dd HH:mm:ss
 */

/**
 * 生成随机字符串
 */
export function toAnyString() {
  const str: string = 'xxxxx-xxxxx-4xxxx-yxxxx-xxxxx'.replace(/[xy]/g, (c: string) => {
    const r: number = (Math.random() * 16) | 0
    const v: number = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString()
  })
  return str
}

/**
 * 首字母大写
 */
export function firstUpperCase(str: string) {
  return str.toLowerCase().replace(/( |^)[a-z]/g, (L) => L.toUpperCase())
}

/**
 * 把对象转为formData
 */
export function objToFormData(obj: Recordable) {
  const formData = new FormData()
  Object.keys(obj).forEach((key) => {
    formData.append(key, obj[key])
  })
  return formData
}


export const copyText = async (text: string) => {
  await navigator.clipboard.writeText(text);
  console.log('文本已复制到剪贴板:', text);
  ElMessage.success(`复制成功 「${text}」`)
}




/**
 * 替换或添加域名
 * @param url 
 * 文件链接，支持以下格式
 * - http://www.qq.com/app/a.png
 * - https://www.qq.com/app/a.png
 * - www.qq.com/app/a.png
 * -
 * @param domain 
 * 要替换的域名 需带协议
 * @returns 
 */
export const replaceOrAddDomain = (path: string, domain: string) => {
  let url = path.trim();
  // 规范化域名（移除末尾斜杠）
  const normalizedDomain = domain.endsWith('/') ? domain.slice(0, -1) : domain;
  // 正则判断url 是否包含域名如 a.xx.ccc/
  const hasDomain = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/|\?|#|$)/i;
  // 情况1：输入为纯路径（如 "app/a.png" 或 "/app/a.png"）
  if (!hasDomain.test(url)) {
    return `${normalizedDomain}/${url.startsWith('/') ? url.slice(1) : url}`;
  }
  // 情况2：输入包含协议或域名（如 "http://old.com/app/a.png"）
  try {
    let oldDomain = '';
    if (url.includes('://')) {
      url = url.split('://')[1];
    }
    oldDomain = url.split('/')[0];
    const param = url.split(oldDomain)[1]
    return `${normalizedDomain}${''}${param || ''}`;
  } catch (e) {
    // 其他情况（如无效URL）直接拼接
    return `${normalizedDomain}/${url}`;
  }
}